document.addEventListener("click", function (e) {
  const clicked = e.target.closest("[collection-name]");
  if (!clicked) return;

  const clickedName = clicked.getAttribute("collection-name").trim();
  if (clicked.classList.contains("show")) return;

  const matchingElements = document.querySelectorAll(`[collection-name="${clickedName}"]`);
  const scrollTarget = Array.from(matchingElements).find(el => el !== clicked);

  if (scrollTarget && !scrollTarget.classList.contains("show")) {
    scrollTarget.classList.remove("hide");
    scrollTarget.classList.add("show");

    setTimeout(() => {
      const offset = 250;
      const scrollY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: scrollY, behavior: 'smooth' });
    }, 50);

    const slider = scrollTarget.querySelector(".card-slider");
    const disableLooping = slider?.dataset?.disableLoop && slider?.dataset?.disableLoop === "true"
    if (slider) {
      const $slider = $(slider);
      const itemCount = $slider.children().length;
      const screenWidth = window.innerWidth;

      const shouldInitSlider = (screenWidth > 768 && itemCount > 3) || (screenWidth <= 768 && itemCount > 1);

      if (shouldInitSlider) {
        setTimeout(() => {
          const width = slider.offsetWidth;

          if (width > 0) {
            if (!$slider.hasClass("slick-initialized")) {
              $slider.on('init', function () {
                $slider.find('.slick-slide').each(function () {
                  const isEmpty = $(this).children().length === 0 && $.trim($(this).text()) === '';
                  if (isEmpty) {
                    $(this).remove();
                  }
                });
              });

              $slider.slick({
                dots: false,
                arrows: true,
                infinite: !disableLooping,
                speed: 300,
                slidesToShow: 4,
                adaptiveHeight: true,
                centerMode: false,
                prevArrow: [
                  '<button type="button" class="slick-prev" aria-label="">',
                  '<span class="custom-arrow"><svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>',
                  '</button>',
                ].join(''),
                nextArrow: [
                  '<button type="button" class="slick-next" aria-label="">',
                  '<span class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>',
                  '</button>',
                ].join(''),
                responsive: [
                  { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true } },
                  { breakpoint: 549, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true } },
                  { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } },
                ],
              });
            } else {
              $slider.slick("setPosition").slick("slickGoTo", 0);
            }
          } else {
            console.warn("Slider still has width 0 — not initializing");
          }
        }, 100);
      } else {
        console.info("Slider not initialized: not enough items for current screen width.");
      }
    }
  }
  else{
    scrollTarget.classList.remove("show");
    scrollTarget.classList.add("hide");
  }
});